var React = require('react');

function Connect (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.44444 1H10V36H4.44444L0 23.2727L4.44444 1Z","fill":"#CCC8FF","key":0}),React.createElement("path",{"d":"M31 10.7222L9.52174 1L5 21.4167L31 10.7222Z","fill":"#857CF2","key":1}),React.createElement("path",{"d":"M9.52174 35.0282L31 10.7227L5 21.4171L9.52174 35.0282Z","fill":"#4D42CF","key":2})]);
}

Connect.defaultProps = {"width":"34","height":"37","viewBox":"0 0 34 37","fill":"none"};

module.exports = Connect;

Connect.default = Connect;
